import { iMerchant } from "core/kangarooTypes/iMerhant";
import { getMerchant } from "core/Services/MerchantServices";
import { Loader } from "lucide-react";
import { useEffect, useState } from "react";
import BusinessInfoForm from "./BusinessInfoForm";
import AddressManagement from "./AddressManagement";
import { USER_ID } from "utils/constant";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ProfileManagement = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [merchantData, setMerchantData] = useState<iMerchant | null>(null);

  const fetchMerchant = async () => {
    try {
      setIsLoading(true);
      const userId = await localStorage.getItem(USER_ID);
      const response = await getMerchant(userId!);
      if (response && response.data) {
        setMerchantData(response.data);
      }
    } catch (error) {
      toast.error(t("profileManagement.fetchError"));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchant();
  }, []);

  return (
    <div className="container mx-auto px-4 py-6 md:px-6 lg:px-8">
      {isLoading ? (
        <div className="flex justify-center items-center h-full min-h-[500px]">
          <Loader size={48} className="animate-spin text-gray-500" />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="bg-gray-100 p-4 rounded-lg">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center">
              <div className="mb-4 md:mb-0">
                <h1 className="text-xl md:text-2xl font-semibold mb-2">
                  {t("profileManagement.title")}
                </h1>
                <p className="text-gray-600 text-sm md:text-base">
                  {t("profileManagement.subtitle")}
                </p>
              </div>
            </div>
          </div>

          <BusinessInfoForm initialData={merchantData!} />

          <AddressManagement initialData={merchantData} />
        </div>
      )}
    </div>
  );
};

export default ProfileManagement;
